export const getTranslationKey = (options) => {
    const [k] = options || [];
    return Array.isArray(k) ? String(k[0]) : String(k);
};
export const getTranslationFallbackKeys = (options) => {
    const [k] = options || [];
    return Array.isArray(k) ? k.slice(1).map(String) : [];
};
export const getTranslationParams = (options) => {
    const [, k] = options || [];
    const dictionary = typeof k === 'object' ? k : {};
    const excludedTransProps = ['t', 'components'];
    return Object.entries(dictionary).filter(([key]) => !excludedTransProps.includes(key));
};
//# sourceMappingURL=getTranslationKey.js.map